import { render, staticRenderFns } from "./coupon_task.vue?vue&type=template&id=73d41ec1"
import script from "./coupon_task.vue?vue&type=script&lang=js"
export * from "./coupon_task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports